package nl.astraeus.midi

enum class NoteLength(val glyph: String) {
  DOUBLE("\ue0a0"),
  WHOLE("\ue0a2"),
  HALF("\ue0a3"),
  QUARTER("\ue0a4"),
  EIGHTEENTH("\ue0a4"),
  SIXTEENTH("\ue0a4"),
}
